import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { viewModuleDataFilters } = apiStoreLenses

export default state => viewModuleDataFilters(state)
